<div *ngIf="loaderService.isLoading | async" id="pause" class="d-flex align-items-center justify-content-center">
    <div id="spinner"></div>
</div>
<div class="row p-4">
    <div class="col-md-12 text-center">
        <h5> Additional Business Activity Questions</h5>
    </div>
</div>
<div class="row">
    <div class="col-md-12 text-right">
        <label class="boldlbl"><span class="errorMsg">*</span>indicates required field.</label>
    </div>
</div>
<form [formGroup]="eappregBusinessQuestions" (ngSubmit)="eappreg_business_questions_action()">
<div class="card">
    <div class="card-body">
        
            <div class="row" id="qRows">
                <div class="col-md-12">
                    <ng-container *ngIf= "qQuestions?.length > 0 ">
                        <table id="level_table" class="table table-bordered">
                            <!--- Loops thru questions in VARIABLES.qQuestions query object --->
                            <jhi-dsp-questions-answers [qQuestions]="qQuestions" [parentForm]="eappregBusinessQuestions"
                            [DispOnlyInd]="DispOnlyInd"  [DispSeqInd]="DispSeqInd" (answerAdded)="update($event)" style="display:contents">
                        </jhi-dsp-questions-answers>
                        </table>
                        <input type="hidden" id="hHasNextPage" [value]="hasNextPage"/>
                        <input type="hidden" id="hHasPrevPage" [value]="hasPrevPage"/>
                    </ng-container>
                </div>
            </div>
    </div>
</div>
<div>
    <br>
</div>
<div class="row text-center">
    <div class="col-md-12">
        <input type="button" class="btn btn-primary my-2" id="prevPageNav" style="display:none" value="See Previous Questions" (click)="ClkNavigattion($event)"/>&nbsp;
        <input type="button" class="btn btn-primary my-2"  [routerLink]="['/eappreg_questionnaire']"  value="Back"/>&nbsp;
        <button class="btn btn-primary my-2" id="bSubmit" type="submit" style="display:none">Accept and Proceed</button>&nbsp;
        <input type="button" class="btn btn-primary my-2" id="nextPageNav" (click)="ClkNavigattion($event)" style="display:none"  value="See Next Questions"/>
    </div>
</div>
<div>
    <br>
</div>
</form>

    